import React from 'react'
import logo from '../../Image/logo.png'

const DevelopService = () => {
  return (
    <div>
        <div className='container'>
          <div className='bg-theme_dark rounded-[30px] p-5 my-14'>
              <h3 className='sm:text-[40px] text-[28px] text-center font-[700] text-white'>Web Application Development Services</h3>
              <p className='sm:text-[16px] text-[14px] text-center text-white mt-2'>Innovative Responsive Web Design Alongside Unrivaled Expertise</p>
              <div className='bg-white ds_develop_show rounded-[30px] mt-5'>
                  <div className='pt-11 flex justify-center'>
                      <div className='w-2/3'>
                         <div className='ds_develop_gradient flex justify-center'>
                            <img src={logo} alt="" className='w-[190px] py-2' />
                         </div>
                      </div>
                  </div>

                  <div className='sm:mt-11 mt-5 pt-2 sm:pb-11 pb-5'>
                      <div className='flex flex-wrap 3xl:px-11 2xl:px-8 sm:px-5 px-3 sm:pb-5'>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border md:relative static md:[border-right:1px_solid!important] [border-right:none!important]'>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>1</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>Responsive Web Design Services</p>
                                </div>
                             </div>
                          </div>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border lg:relative static lg:[border-right:1px_solid!important] [border-right:none!important]'>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>2</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>Interface Design Services</p>
                                </div>
                             </div>
                          </div>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border 2xl:relative lg:static md:relative 2xl:[border-right:1px_solid!important] xl:[border-right:none!important] lg:[border-right:none!important] md:[border-right:1px_solid!important] [border-right:none!important]'>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>3</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>Feature-Rich And Advanced Web Design</p>
                                </div>
                             </div>
                          </div>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border 2xl:static lg:relative static border-none 2xl:[border-right:none!important] lg:[border-right:1px_solid!important] [border-right:none!important]'>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>4</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>Highly Impressive and Professional Design</p>
                                </div>
                             </div>
                          </div>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border md:relative static 2xl:[border-bottom:none!important] md:[border-right:1px_solid!important] [border-right:none!important]'>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>5</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>Adaptive Web Design</p>
                                </div>
                             </div>
                          </div>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border 2xl:relative 2xl:[border-bottom:none!important] 2xl:[border-right:1px_solid!important] xl:[border-right:none!important] lg:[border-right:none!important] [border-right:none!important]'>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>6</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>Liquid Web Design</p>
                                </div>
                             </div>
                          </div>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border md:relative static md:[border-bottom:none!important] md:[border-right:1px_solid!important] [border-right:none!important] '>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>7</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>User Interface & Front-end Design</p>
                                </div>
                             </div>
                          </div>
                          <div className='2xl:w-1/4 lg:w-1/3 md:w-1/2 w-full'>
                             <div className='ds_develop_border [border-right:none!important] [border-bottom:none!important]'>
                                <div className='flex items-center 3xl:px-10 2xl:px-5 sm:px-4 px-2'>
                                   <h3 className=' sx:w-1/6 w-1/5 sm:text-[75px] sx:text-[60px] text-[55px] font-[600] text-theme_dark'>8</h3>
                                   <p className=' sx:w-5/6 w-4/5 sm:text-[18px] sx:text-[16px] text-[14px] md:ms-5 text-theme_dark'>Landing Page Redesign & Optimization</p>
                                </div>
                             </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </div>
  )
}

export default DevelopService
